import type { ComponentOverride } from '../types';

export const MuiTextField: ComponentOverride<'MuiTextField'> = {
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiInputBase-inputAdornedEnd': {
          '&[id="date-picker-inline-small"] + div': {
            '& svg': {
              width: '1rem',
              height: '1rem',
            },
          },
          '&[class*="MuiInputBase-input"] + div': {
            '& svg': {
              width: '1.2rem',
              height: '1.2rem',
            },
          },
        },
        // Remove arrows on number field
        '& input[type=number]': {
          MozAppearance: 'textfield',
          '::-webkit-inner-spin-button, ::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
          },
        },
      },
    },
  },
};
